import * as React from 'react';
import { status } from '../constants';
import {abbreviationName} from '../../../../common/util';
import UserImage from '../../../../components/UserImage/index';

export default class WorkkardTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.renderTemplate = this.renderTemplate.bind(this);
    }

    renderTemplate(data, type) {
        switch (type) {
            case "Update":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a>{` has been edited `}
                        </span>
                    </React.Fragment>
                );

            case "NoteAdded":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        {(data.NoteText != "") ?
                            <><a href={data.WorkkardNoteDetailUrl}>{data.NoteText}</a> note has been added in <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                            :
                            <>A <a href={data.WorkkardNoteDetailUrl}>Note</a> has been added to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                        }
                        </span>
                    </React.Fragment>
                );
            case "NoteWithFileOnlyAdded":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        {(data.NoteTemplateName != "") ?
                            <><a href={data.WorkkardNoteDetailUrl}>File(s)</a> have been added with <a href={data.WorkkardNoteDetailUrl}>{data.NoteTemplateName}</a>, for <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                            :
                            <><a href={data.WorkkardNoteDetailUrl}>File(s)</a> have been added in <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                        }
                        </span>
                    </React.Fragment>
                );
            case "NotePublished":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        {(data.NoteText != "") ?
                            <><a href={data.WorkkardNoteDetailUrl}>{data.NoteText}</a> note has been published in <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                            :
                            <>A <a href={data.WorkkardNoteDetailUrl}>Note</a> has been published to <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                        }
                        </span>
                    </React.Fragment>
                );

            case "PrivateWorkkardNoteAdded":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        {(data.NoteText != "") ?
                            <><a href={data.WorkkardNoteDetailUrl}>{data.NoteText}</a> note has been added in <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                            :
                            <>A <a href={data.WorkkardNoteDetailUrl}>Note</a> has been added to <a href={data.ActivityDetailUrl} title={data.ActivityTitleFull}>{data.ActivityTitle}</a> in <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                        }
                        </span>
                    </React.Fragment>
                );

            case "PrivateWorkkardNoteWithFileOnlyAdded":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        {(data.NoteTemplateName != "") ?
                            <><a href={data.WorkkardNoteDetailUrl}>File(s)</a> have been added with <a href={data.WorkkardNoteDetailUrl}>{data.NoteTemplateName}</a>, for <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                            :
                            <><a href={data.WorkkardNoteDetailUrl}>File(s)</a> have been added in <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                        }
                        </span>
                    </React.Fragment>
                );

            case "PrivateWorkkardNotePublished":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        {(data.NoteText != "") ?
                            <><a href={data.WorkkardNoteDetailUrl}>{data.NoteText}</a> note has been published in <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                            :
                            <>A <a href={data.WorkkardNoteDetailUrl}>Note</a> has been published to <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                        }
                        </span>
                    </React.Fragment>
                );

            case "PrivateWorkkardNoteWithFileOnlyPublished":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        <a href={data.WorkkardNoteDetailUrl}>File(s)</a> have been published in <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a>
                        </span>
                    </React.Fragment>
                );

            case "PersonalWorkkardNotePrivatePublished":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        {(data.NoteText != "") ?
                            <><a href={data.WorkkardNoteDetailUrl}>{data.NoteText}</a> note has been published in <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                            :
                            <>A <a href={data.WorkkardNoteDetailUrl}>Note</a> has been published to <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                        }
                        </span>
                    </React.Fragment>
                );

            case "PersonalWorkkardNoteWithFileOnlyPrivatePublished":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        <a href={data.WorkkardNoteDetailUrl}>File(s)</a> have been published in <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a>
                        </span>
                    </React.Fragment>
                );

            case "PersonalWorkkardNotePublicPublished":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        {(data.NoteText != "") ?
                            <><a href={data.WorkkardNoteDetailUrl}>{data.NoteText}</a> note has been published in <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                            :
                            <>A <a href={data.WorkkardNoteDetailUrl}>Note</a> has been published in <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a></>
                        }
                        </span>
                    </React.Fragment>
                );
            case "PersonalWorkkardNoteWithFileOnlyPublicPublished":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        <a href={data.WorkkardNoteDetailUrl}>File(s)</a> have been published in <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a>
                        </span>
                    </React.Fragment>
                );
            case "Watcher":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        <a href={data.TriggeredByUserProfile} className="name" title={data.TriggeredByFullNameFull}>{data.TriggeredByFullName}</a> invited you to follow <a href={data.WorkkardDetailUrl} title={data.WorkkardNoFull}>{data.WorkkardNo}</a>
                        </span>
                    </React.Fragment>
                );
        }
    }

    render() {
        const {extraData}=this.props;
        return (
            <div className={extraData.displayMarkReadIcon ? (`card ${extraData.IsGroupByEnabled  && !extraData.showGroupedNotificationDetail ? 'cardGroup' :'cardPlain'} ${this.props.data.Status == status.read ? 'cardGroupRead' : ''}`):''} onClick={()=>{(extraData.IsGroupByEnabled && !extraData.showGroupedNotificationDetail) ? this.props.handleCardClick(this.props.data) :false}}>
                {
                    extraData.displayMarkReadIcon && 
                    <React.Fragment>
                        {
                            <span className="posRight quickTooltip-bottom" data-quicktooltip={this.props.data.Status == status.read ? "mark as unread": "mark as read"} 
                            onClick={(e)=>{
                                e.stopPropagation();
                                        if(this.props.data.Status == status.read)
                                            extraData.handleMarkRead(this.props.data,status.unRead)
                                        else
                                            extraData.handleMarkRead(this.props.data,status.read)
                                        }}>
                                <em className={`read ${this.props.data.Status == status.read ? "unread":""}`}></em>
                            </span>
                        }
                        {extraData.IsGroupByEnabled && !extraData.showGroupedNotificationDetail?<div className="rwoFlex alignMiddle wkNumber">
                            <label className="badges wkSymbol mr__1">{this.props.data.WorkkardId?'W':'0'}</label> {this.props.data.WorkkardNo?this.props.data.WorkkardNo:'Others'}
                            {
                                extraData.IsGroupByEnabled && extraData.GroupNotificationCounter > 0 && <label className="newCard ml__1">{extraData.GroupNotificationCounter > 99 ? '99+' : extraData.GroupNotificationCounter} new{extraData.RecentWorkkardCountRecieved && <span className="newCardNotification"></span>}</label>
                            }
                        </div> : this.props.data.AllNotificationCount > 0 ? <div className="rwoFlex alignMiddle"><label className="newCard">new</label></div> : null} 
                    </React.Fragment>
                }
                <div className={extraData.displayProfilePic ? "rowFlex mt activity_desc":"rowFlex activity_desc"}>
                    {
                        extraData.displayProfilePic && 
                        <div className="badges badgesSmall mr">
                             <UserImage profileUrl={this.props.data.TriggeredByProfileImage} size="22" className="profilePic" profileName={this.props.data.TriggeredByFullName}/>
                        </div>
                    }
                    <div className={extraData.displayProfilePic ?"":"notificationDate"}>  
                        {
                            extraData.displayTriggerByName && 
                            <>
                                <span className="userName flexGrow" onClick={(e)=>extraData.onProfileClick(e,this.props.data.TriggeredById,'user')}>{this.props.data.TriggeredByFullName}</span>
                                {extraData.showGroupedNotificationDetail && <label>{abbreviationName(this.props.data.TriggeredByOrganisationNameFull)}</label>}
                            </>
                        }                                
                        {this.renderTemplate(this.props.data, this.props.type)}
                        <label className={extraData.displayProfilePic ? "notification__time" : "notification__time gray"}>{extraData.displayProfilePic ? this.props.data.CreatedDate.split("at")[1] : this.props.data.CreatedDate}</label>
                    </div>
                </div>
            </div>
        );
    }
}